// Storefront-notaties die bovenop een leverancierswaarde liggen. De vormpresets
// "Rond" en "Afgeronde hoeken" (zie custom-shape-presets.ts) heten in de
// configurator `custom_shape_simple|shape:<vorm>`; Print.com kent en echoot
// alleen `custom_shape_simple`.
const SHAPE_SUFFIX = '|shape:';

export function toProviderOptionValue(optionId: string, value: unknown): string {
  const text = String(value ?? '');
  if (optionId !== 'custom_shape' || !text.includes(SHAPE_SUFFIX)) return text;
  return text.split(SHAPE_SUFFIX)[0] || text;
}

export function sameProviderOptionValue(optionId: string, requested: unknown, echoed: unknown): boolean {
  return toProviderOptionValue(optionId, requested) === toProviderOptionValue(optionId, echoed);
}
